<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        جزئیات فاکتور
        <span class="close" (click)="close()">
            <mat-icon>close</mat-icon>
        </span>
    </div>
</div>


<div mat-dialog-content class="matDialogContent" style="max-height:90vh;padding:0px !important">
    <div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
        style='overflow-x:auto;direction:rtl;'>
        <mat-table [dataSource]="dataSource" style='min-width:100%'
            class='table-scroll mat_table_fa_without_scroll_bg mat_table_fa_without_scroll_bg not- pe1'
            [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}" [ngStyle]="lang == 2 && {direction:'ltr'}">
            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style="max-width:70px">
                    #
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:70px">{{ i+1 }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="image">
                <mat-header-cell *matHeaderCellDef style="max-width: 100px;">
                    <span *ngIf="lang == 1">عکس</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor logo" style="max-width: 100px;"
                    [ngStyle]="{'background-image':'url( ' + x.logo + ')'}">

                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">عنوان کالا</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor right">
                    <div class="right">{{x.wharehouse_material_title | substr:0:30 }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cate2">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">دسته میانی</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor right">
                    <div class="right"> {{ x.wharehouse_material_cate2_title }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="number">
                <mat-header-cell *matHeaderCellDef style="max-width:70px">
                    <span *ngIf="lang == 1">مقدار</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" style="max-width:70px">
                    <div> {{ x.wharehouse_order_number }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="price">
                <mat-header-cell *matHeaderCellDef style="max-width:130px">
                    <span *ngIf="lang == 1">قیمت واحد به تومان</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" style="max-width:130px">
                    {{
                    x.wharehouse_order_cost | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="sum">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1"> قیمت کل به تومان بدون تخفیف </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor">
                    {{
                    x.sum | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="discount">
                <mat-header-cell *matHeaderCellDef style="max-width:130px">
                    <span *ngIf="lang == 1"> تخفیف به تومان </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" style="max-width:130px">
                    {{
                    x.wharehouse_order_discount | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="sum_with_discount">
                <mat-header-cell *matHeaderCellDef style="max-width:130px">
                    <span *ngIf="lang == 1"> قیمت به تومان با تخفیف</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" style="max-width:130px">
                    {{
                    x.sum_with_discount | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="tax">
                <mat-header-cell *matHeaderCellDef style="max-width:130px">
                    <span *ngIf="lang == 1"> ارزش افزوده به تومان </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" style="max-width:130px">
                    {{
                    x.tax | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="zarayeb">
                <mat-header-cell *matHeaderCellDef style="max-width:70px">
                    <span *ngIf="lang == 1">جمع ظرایب</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" style="max-width:70px">
                    {{
                    x.zarayeb }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="sum_final">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">قیمت نهایی به تومان </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor">
                    {{
                    x.sum_final | number }}</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
            <mat-row *matRowDef="let x;let i = index;columns:displayedColumns"
                (click)="get_bg(x.wharehouse_material_id)"
                (keyup.enter)="select(x.wharehouse_material_id,x.wharehouse_material_title)"
                [ngClass]="{mat_table_selected:row_id == x.wharehouse_material_id}"></mat-row>
        </mat-table>
    </div>
</div>


<div mat-dialog-actions class="matDialogActions" style="padding-top:0px">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 div_panding"
        style="text-align: right;padding-top:8px">
        (
        قیمت کل بدون تخفیف {{ sum_all | number }} تومان
        )

        (
        مقدار تخفیف {{ discount_all | number }} تومان
        )

        <span>
            (
            قیمت با تخفیف
            {{ sum_with_discount | number }} تومان
            )
        </span>
        +
        <span>
            (
            ارزش افزوده
            {{ tax | number }} تومان
            )
        </span>

        <span style="background-color: #8df178">
            (
            قیمت نهایی
            {{ sum_final | number }} تومان
            )
        </span>

    </div>
</div>